// TYPES
import { StudioConfig } from "../types";
// CONFIGS
import studio_config from "../../../../configs/studio.json";

export async function mostApplicableFormatAndAspectRatio(dimensions: { height: number; width: number }, formatType: string, selectedFormat: string, notificationDispatch: any): Promise<{ format: string; aspectRatio: string; incomingAspectRatio: string }> {
  const studioConfig: StudioConfig = studio_config;

  if (selectedFormat) {
    /**
     * JA (30-08-23)
     * Set the default aspect ratio to the first applicable one for the selected format.
     */
    const aspectRatio = studioConfig.formats[selectedFormat].media.frameRatios[0].name;
    return { format: selectedFormat, aspectRatio, incomingAspectRatio: "" };
  }
  /**
   * HTL (14-06-23)
   * Using a recursive GCD algorithm to find the greatest common denomenator, the largest number that divides them both without a remainder.
   * https://en.wikipedia.org/wiki/Euclidean_algorithm
   */
  function gcd(a: number, b: number): number {
    return b == 0 ? a : gcd(b, a % b);
  }
  const incomingGcd = gcd(dimensions.width, dimensions.height);
  const incomingAspectRatio = `${dimensions.width / incomingGcd}:${dimensions.height / incomingGcd}`;

  let format = "";
  let aspectRatio = "";

  /**
   * HTL (14-06-23)
   * Adding in known aspect ratios and their mapping.
   * This isn't an ideal solution as it's quite manual, and isn't future proofed in case one of these aspect ratios is deprecated.
   */

  // story 4:5
  if (incomingAspectRatio === "4:5") {
    format = "story";
    aspectRatio = "4:5";
  }
  // story 9:16
  if (incomingAspectRatio === "9:16") {
    format = "story";
    aspectRatio = "9:16";
  }
  // post landscape (16:9)
  if (dimensions.width > dimensions.height) {
    if (incomingAspectRatio !== "16:9") {
      notificationDispatch({
        type: "ADD",
        payload: {
          header: "Warning",
          message: "The asset detected is not a standard aspect ratio, cropping may be required",
          type: "warning",
          autoDismiss: false,
        },
      });
    }
    format = "post";
    aspectRatio = "landscape";
  }
  // post picnic (8:7)
  if (incomingAspectRatio === "8:7") {
    format = "post";
    aspectRatio = "picnic";
  }
  // post / carousel square (1:1)
  if (incomingAspectRatio === "1:1") {
    format = formatType === "carousel" ? "carousel" : "post";
    aspectRatio = "square";
  }

  /** final fallback options if incomingAspectRatio doesn't satisfy any of the above if() statements */
  if (!format) format = "story";
  if (!aspectRatio) aspectRatio = studioConfig.formats[format].media.frameRatios[0].name;

  return { format, aspectRatio, incomingAspectRatio };
}
